import React from 'react'
import styled from 'styled-components';
import Particle from '../Components/Particle';
import { Link } from 'react-router-dom';


function HomePage() {
    
    return (
        <>
        <title>Foxicode | Portfolio</title>
        <HomePageStyled>
            <div className="particle-con">
                <Particle />
            </div>
            <div className="typography">
                <h1 className="title-text">Hi, <br/>I'm <span>Dika,</span> <br/> web developer</h1>
                <p className="desc-text">Front End Developer / Web Developer</p>
                <ButtonContainer to="/contact">
                    <Button>Contact Me!</Button>
                </ButtonContainer>
            </div>
        </HomePageStyled>
        </>
    )
}

const ButtonContainer = styled(Link)`
    display: flex;

`
const Button = styled.button`
    height: 48px;
    width: 205px;
    color: #c46500;
    font-size: 20px;
    letter-spacing: 2px;
    background-color: transparent;
    border: 2px solid #c46500;
    cursor: pointer;
    border-radius: 2px;
    transition: 0.5s ease;
    font-weight: 500;
    text-decoration: none;

    @media screen and (max-width: 768px) {
        height: 40px;
        width: 175px;
        font-size: 15px;
    }

    &:hover {
        transition: 0.5s ease;
        background-color: #c46500;
        color: #ece1cb;
    }
`

const HomePageStyled = styled.header`
    width: 100%;
    height: 100vh;
    position: relative;
   
    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 80%;
        }

        .desc-text{
        letter-spacing: 5px;
        font-weight: 100;
        font-size: 20px;
        text-align: left;
        color: var(--font-light-desc);
        margin-top: 20px;
        margin-bottom: 50px;

        @media screen and (max-width: 768px) {
            font-size: 12px;
            letter-spacing: 2px;
        }
        }

        .title-text{
        text-align: left;
        font-size: 105px;
        letter-spacing: normal;
        color: var(--font-light-color);
        
        @media screen and (max-width: 768px) {
            font-size: 2.5rem;
        }

        br {
            margin: -35px;
            content: "";
            display: block;

            @media screen and (max-width: 768px) {
            margin: 0;
        }
        }

        span{
            font-size: 105px;
            color: #c46500;

            @media screen and (max-width: 768px) {
            font-size: 2.5rem;
        }
        }
        }

        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:hover{
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                }
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }
        }
`;

export default HomePage;
